<template>
  <NuxtImg
    :src="sponsorCoverUrl"
    :alt="sponsor.name"
    :class="styledClass"
    loading="lazy"
    @click="handleClick"
  />
</template>

<script setup>
  defineOptions({
    name: "SponsorCard",
  })

  const props = defineProps({
    sponsor: {
      type: Object,
      required: true,
    },
    thumbnail: {
      type: Boolean,
      default: false,
    },
  })

  const { inMembersArea } = useMembersArea()
  const { ageRestrictionFlag } = useFeatureFlags()
  const linkPrefix = inMembersArea.value ? "/members" : ""
  const sponsorUrl = `${linkPrefix}/series/${props.sponsor.cachedSlug}`
  const styledClass = props.thumbnail
    ? "cursor-pointer"
    : "cursor-pointer w-full"
  const handleClick = () => {
    navigateTo(sponsorUrl)
  }

  const sponsorCoverUrl = computed(() => {
    if (ageRestrictionFlag) {
      return props.sponsor.coverUrl.replace(/\.(jpg|png)/, "_SFW.$1")
    } else {
      return props.sponsor.coverUrl
    }
  })
</script>
